<template>
  <div class="btn-group">
    <template>
      <div class="ing" v-if="button_list.indexOf(108)>=0 || button_list.indexOf(110)>=0">
        <img v-show="button_list.indexOf(108)>=0" src="@/assets/image/bargin/refund.png" alt="" />
        {{  button_list.indexOf(108)>=0 ? '正在验号...' : '等待买家确认验号结果...' }}
      </div>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(101)>=0" @click.stop="$emit('pullPlugUpset')" class="btn btn-muted">终止</el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(102)>=0" @click.stop="$emit('agreeUpset', 2)" class="btn btn-danger">拒绝</el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(103)>=0" @click.stop="$emit('counteroffer')" class="btn border-5B5B5B">还价</el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(104)>=0" @click.stop="$emit('agreeUpset', 1)" class="btn bg-FFDB51">同意</el-button>
      <el-button :disabled="disabled || rowData.last_urge_timestamp>0" v-preventReClick='1000' v-show="button_list.indexOf(105)>=0" @click.stop="$emit('hasten')" class="btn bg-FFDB51" :class="rowData.last_urge_timestamp>0?'btn-disabled':''">
        催促
        <template v-if="rowData.last_urge_timestamp>0">
          <count-down class="count_down" :end-time="rowData.last_urge_timestamp" :start-time="getNowTime" :key="rowData.id" format="ms" @countDownChange="$emit('nextUrgeTimeChange')" @timeChange="(val) => (time = val)">
          <template v-if="time">
            ({{ time }})
          </template>
        </count-down>
        </template>
      </el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(106)>=0" @click.stop="$emit('hasten')" class="btn bg-FFDB51">催付款</el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(107)>=0" @click.stop="$emit('sendPsd')" class="btn bg-FFDB51 w-88">发送账密</el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(109)>=0" @click.stop="$emit('cusSerBtnClicks')" class="btn bg-FFDB51 w-88">联系客服</el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(112)>=0" @click.stop="$emit('GoGroup')" class="btn bg-FFDB51">进群</el-button>
      <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(116)>=0" @click.stop="$emit('closeRemind')" class="btn bg-FFDB51 w-88">提醒买家</el-button>
    </template>
  </div>
</template>

<script>
import countDown from "@/components/countDown";
export default {
  components: {
    countDown
  },
  props: {
    rowData: {
      type: Object,
      default: () => ({}),
    },
    button_list: {
      type: Array,
      default: () => {
        return []
      },
    }
  },
  data() {
    return {
      disabled: false,
      time: "",
    }
  },
  computed:{
    getNowTime() {
      return new Date().getTime() / 1000;
    },
  },
};
</script>

<style lang="less" scoped>
.btn-group{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  .ing{
    min-height: 30px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    color: var(--primary, #FF5A1F);
    background: var(--primary-soft, #FCEDE5);
    border-radius: 4px;
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.24px;
    img{
      width: 17px;
      height: 17px;
      margin-right: 5px;
    }
  }
  .btn{
    display: flex;
    min-width: 64px;
    height: 32px;
    padding: 0 14px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1.5px solid var(--bg-dark, #1A1D24);
    background: var(--bg-card, #FFFFFF);
    color: var(--text-main, #1A1D24);
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    box-shadow: none;
    transition: color .2s ease, background .2s ease, border-color .2s ease, box-shadow .2s ease, opacity .2s ease;

    &:hover,
    &:focus{
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
      border-color: var(--bg-dark, #1A1D24);
    }
  }
  .el-button+.el-button{
    margin-left: 0;
  }
  .border-5B5B5B{
    border-color: var(--bg-dark, #1A1D24);
    color: var(--text-main, #1A1D24);
    background: var(--bg-card, #FFFFFF);
  }
  .bg-FFDB51{
    border-color: transparent;
    background: var(--primary, #FF5A1F);
    color: #FFFFFF;
    box-shadow: none;

    &:hover,
    &:focus{
      color: #FFFFFF;
      border-color: transparent;
      background: var(--primary-hover, #E84A12);
      box-shadow: none;
    }
  }
  .btn-muted{
    color: var(--text-secondary, #5A5F6B);
    border-color: var(--border-soft, #E8E4DE);
    background: var(--bg-tag, #F0EDE8);

    &:hover,
    &:focus{
      color: var(--text-main, #1A1D24);
      border-color: var(--bg-dark, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }
  }
  .btn-danger{
    color: var(--danger, #EF4444);
    border-color: var(--danger-soft, #FEF2F2);
    background: var(--danger-soft, #FEF2F2);

    &:hover,
    &:focus{
      color: var(--danger, #EF4444);
      border-color: var(--danger, #EF4444);
      background: var(--danger-soft, #FEF2F2);
    }
  }
  .w-88{
    width: 88px;
    min-width: 88px;
  }
  .btn-disabled{
    width: auto;
    color: var(--text-muted, #9AA0AC) !important;
    background: var(--bg-tag, #F0EDE8) !important;
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE) !important;
    box-shadow: none;
  }
}
</style>
